

























import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IBasketProviderData } from "@/models/providers/baskets";

@Component({
  components: {
    "basket-promotions": () =>
      import("@/components/app/global/baskets/basket/basketPromos.vue"),
    "basket-totals": () =>
      import("@/components/app/global/baskets/basket/basketTotals.vue")
  }
})
export default class BasketControl extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  public get basketData() {
    return this.$basketData();
  }

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public showContinueButton!: boolean;
}
